import {
    createRouter,
    createWebHistory,
    createWebHashHistory,
} from "vue-router";
import StepOne from "../components/pages/StepOne.vue";
import StepTwo from "../components/pages/StepTwo.vue";
import StepThree from "../components/pages/StepThree.vue";
import CustomizerFallback from "../components/CustomizerFallback.vue";
import { getCleanPagePath } from "../utils/tracking";

const getCustomizerRedirect = (to) => {
    const hashMatch = (to.hash || "").match(
        /^#\/([^/?#]+)\/(step[123])(?:[?#].*)?$/
    );
    const variant = hashMatch?.[1] || to.query.variant;
    const step = hashMatch?.[2] || to.query.step || "step1";

    if (!variant || !/^step[123]$/.test(step)) {
        return undefined;
    }

    const query = { ...to.query };
    delete query.variant;
    delete query.step;

    return {
        path: `/${variant}/${step}`,
        query,
        replace: true,
    };
};

const routes = [
    {
        path: "/",
        name: "CustomizerFallback",
        component: CustomizerFallback,
        beforeEnter: getCustomizerRedirect,
    },
    {
        path: "/:bookId/step1",
        name: "StepOne",
        component: StepOne,
    },
    {
        path: "/:bookId/step2",
        name: "StepTwo",
        component: StepTwo,
    },
    {
        path: "/:bookId/step3",
        name: "StepThree",
        component: StepThree,
    },
    {
        path: "/pages/customizer/:pathMatch(.*)*",
        name: "CustomizerPreviewRecovery",
        component: CustomizerFallback,
        beforeEnter: getCustomizerRedirect,
    },
    {
        path: "/:pathMatch(.*)*",
        name: "CustomizerFallbackCatchAll",
        component: CustomizerFallback,
    },

];

const router = createRouter({
    history:
        process.env.VUE_APP_DEV_MODE !== "true"
            ? createWebHashHistory("/pages/customizer/")
            : createWebHistory("/"),
    routes,
});



router.afterEach((to) => {

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', sendEvent, { once: true });
    } else {
        sendEvent();
    }
    
    function sendEvent() {
        const cleanPagePath = getCleanPagePath(to);
        const eventData = {
            event: "customizer_page_view",
            page_path: cleanPagePath,
            app_name: "customizer",
            step: to.name || "unknown_step",
            book_id: to.params.bookId || "unknown_book",
        };
        
        if (window.dataLayer) {
            window.dataLayer.push(eventData);
        }
    }
});

export default router;
